// src/components/familytree/TreeActionMenu.js
// Updated: 10/17/2025 02:02 PM

import React from 'react';
import { FaPencilAlt, FaUserPlus, FaUsers, FaHeart } from 'react-icons/fa';

const TreeActionMenu = ({ member, onEdit, onAddSpouse, onAddChild, onClose }) => {
  // We position this menu using absolute coordinates passed from the parent
  return (
    <div className="absolute z-10 bg-white rounded-md shadow-lg border text-sm text-gray-700" onClick={onClose}>
      <div className="py-1">
        <button onClick={() => onEdit(member)} className="flex items-center gap-3 w-full px-4 py-2 hover:bg-gray-100">
          <FaPencilAlt /> Edit {member.firstName}
        </button>
        <button onClick={() => onAddSpouse(member)} className="flex items-center gap-3 w-full px-4 py-2 hover:bg-gray-100">
          <FaHeart /> Add Spouse
        </button>
        <button onClick={() => onAddChild(member)} className="flex items-center gap-3 w-full px-4 py-2 hover:bg-gray-100">
          <FaUserPlus /> Add Child
        </button>
      </div>
    </div>
  );
};

export default TreeActionMenu;